import { pipe } from 'fp-ts/function';
import { map } from 'fp-ts/ReadonlyArray';
import { keys } from 'fp-ts/Record';
import { lt } from '@mews/framework';
import { type SelectionCardGroupProps } from '@optimus-web/core';

export enum RepricingFieldName {
    RepriceExistingReservations = 'repriceExistingReservations',
}

export enum RerpricingOptions {
    ApplyNewPriceToFutureReservations = 'false',
    ApplyNewPriceToFutureAndExistingReservations = 'true',
}

export const repricingLabelMap = {
    ApplyNewPriceToFutureReservations: 'EnterpriseProductEditPricingFormApplyNewPriceFutureOption',
    ApplyNewPriceToFutureAndExistingReservations:
        'EnterpriseProductEditPricingFormApplyNewPriceFutureAndExistingOption',
} as const;

export const groupedRepricingOptions: SelectionCardGroupProps['options'] = [
    ...pipe(
        keys(repricingLabelMap),
        map((key) => ({
            label: lt(repricingLabelMap[key]),
            value: RerpricingOptions[key],
            name: key,
        }))
    ),
];
